import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import CustomRadio from '../../../common/ui/CustomRadio';
import { FileUploadDownload } from '../../../common/formElements/FileUploadDownload';
import EncryptFileTest from './EncryptFileTest';
import DecryptFileTest from './DecryptFileTest';

export default class CypherTest extends Component {
  state = {
    cypherType: '',
    enc_content: '',
    enc_output: '',
    dec_content: '',
    dec_output: '',
  };
  handleOptionChange = (e) => {
    this.setState({ cypherType: e.target.value });
  };

  handleEncText = (values) => {
    const { enc_content } = this.state;
    const { cypherText, envType, projectId, version } = this.props;

    cypherText({ content: enc_content, isDecrypt: false, envType, projectId, version }).then(
      (data) => {
        this.setState({ enc_output: data });
      },
    );
  };
  handleDecText = () => {
    const { dec_content } = this.state;
    const { cypherText, envType, projectId, version } = this.props;
    cypherText({ content: dec_content, isDecrypt: true, envType, projectId, version }).then(
      (data) => {
        this.setState({ dec_output: data });
      },
    );
  };
  handleEncFile = () => {};
  handleDecFile = () => {};

  showInputAndOutput = () => {
    const { cypherType, enc_content, dec_content, enc_output, dec_output } = this.state;
    const { projectId, version, envType } = this.props;
    if (cypherType === 'encrypt_text') {
      return (
        <>
          <div className="col-md-11">
            <div class="form-group">
              <label htmlFor="">Input</label>
              <textarea
                name="enc_content"
                className="form-control"
                value={enc_content}
                onChange={(e) => this.setState({ enc_content: e.target.value })}
              ></textarea>
            </div>
          </div>
          <div className="col-md-1 align-items-center">
            <button type="submit" className="btn btn-primary" onClick={this.handleEncText}>
              Encrypt
            </button>
          </div>
          <div className="col-md-11">
            <div class="form-group">
              <label htmlFor="">Output</label>
              <textarea name="enc_output" value={enc_output} className="form-control"></textarea>
            </div>
          </div>
        </>
      );
    } else if (cypherType === 'decrypt_text') {
      return (
        <>
          <div className="col-md-11">
            <div class="form-group">
              <label htmlFor="">Input</label>
              <textarea
                name="dec_content"
                className="form-control"
                value={dec_content}
                onChange={(e) => this.setState({ dec_content: e.target.value })}
              ></textarea>
            </div>
          </div>
          <div className="col-md-1 align-items-center">
            <button type="button" className="btn btn-primary" onClick={this.handleDecText}>
              Decrypt
            </button>
          </div>
          <div className="col-md-11">
            <div class="form-group">
              <label htmlFor="">Output</label>
              <textarea name="dec_output" className="form-control" value={dec_output}></textarea>
            </div>
          </div>
        </>
      );
    } else if (cypherType === 'encrypt_file') {
      //Don't refactor it, some weird behavior
      return <EncryptFileTest projectId={projectId} version={version} envType={envType} />;
    } else if (cypherType === 'decrypt_file') {
      //Don't refactor it, some weird behavior
      return <DecryptFileTest projectId={projectId} version={version} envType={envType} />;
    }
  };
  render() {
    const { cypherType } = this.state;
    return (
      <div className="col-md-12 col-lg-12 col-sm-12 col-12">
        <div className="form-check pb-5">
          <div className="d-flex justify-content-between align-items-center px-3">
            <CustomRadio label="Encrypt Text" isRadio={true}>
              <input
                name="cypherType"
                type="radio"
                className="form-check-input"
                value="encrypt_text"
                onChange={this.handleOptionChange}
              />
            </CustomRadio>
            <CustomRadio label="Decrypt Text" isRadio={true}>
              <input
                name="cypherType"
                type="radio"
                className="form-check-input"
                value="decrypt_text"
                onChange={this.handleOptionChange}
              />
            </CustomRadio>
            <CustomRadio label="Encrypt File" isRadio={true}>
              <input
                name="cypherType"
                type="radio"
                className="form-check-input"
                value="encrypt_file"
                onChange={this.handleOptionChange}
              />
            </CustomRadio>
            <CustomRadio label="Decrypt File" isRadio={true}>
              <input
                name="cypherType"
                type="radio"
                className="form-check-input"
                value="decrypt_file"
                onChange={this.handleOptionChange}
              />
            </CustomRadio>
          </div>
        </div>

        <div className="row">{this.showInputAndOutput()}</div>
      </div>
    );
  }
}
